var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/08ac76f5fa58f24f420b429fc509a777.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2793719f357c37771437f67822a9b564.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a852c49545556dc3fcbb8fd4e43b74d0.js').default;
var scope_3 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aa5aaf687261fe7b20becb440a433c3e.js').default;
var scope_4 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    